import  { useEffect, useState } from "react";
import "./ThirdReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const ThirdReport = ({ res }) => {
  const [necessityValue, setNecessityValue] = useState("");
  const [offeringValue, setOfferingValue] = useState("");
  const [painSegmentValue, setPainSegmentValue] = useState("");
  const [businessModelValue, setBusinessModelValue] = useState("");

  useEffect(() => {
    if (!res) return;

    // Clean values (remove leading symbols)
    const clean = (v) => (v ? v.replace(/[^a-zA-Z0-9\s]/g, "") : "");

    setNecessityValue(clean(res.necessity));
    setOfferingValue(clean(res.offeringType));
    setPainSegmentValue(clean(res.painSegment));
    setBusinessModelValue(clean(res.businessModel));
  }, [res]);

  // ---------- 2C Necessity ----------
  const necessityContent =
    necessityValue?.toLowerCase().includes("demand")
      ? "If the product is demanded, the benefits include rapid growth, higher margins, and strong branding opportunities."
      : "If the product is needed, focus on quality, affordability, and reliability — because it ensures long-term user trust, steady revenue, and strong investor interest.";

  // ---------- 2D Offering ----------
  const offeringContent =
    offeringValue?.toLowerCase().includes("service")
      ? "If service-related, focus on quality and consistency to grow steadily. Service-based startups generate faster revenue and build customer trust easily."
      : "If product-related, build and test an MVP early, validate the market, and scale strategically to attract investors — product-based startups offer higher scalability and investor appeal once validated.";

  // ---------- 2E Pain Table ----------
  const painData = {
    Metro: {
      category: "Metro / Urban People",
      painLevel: "High",
      revenue: "High",
      why: "Fast life, tech adoption, demand for convenience."
    },
    Town: {
      category: "Town / Semi-Urban People",
      painLevel: "Medium–High",
      revenue: "Very High",
      why: "Growing market, adapting to new lifestyle."
    },
    Block: {
      category: "Block / Rural / Village People",
      painLevel: "Medium",
      revenue: "Moderate",
      why: "Needs strong but purchasing power low."
    },
    Companies: {
      category: "Companies / MSMEs",
      painLevel: "Very High",
      revenue: "Low–Medium",
      why: "Constant need for efficiency, automation, transformation."
    }
  };

  const painContent = painData[painSegmentValue] || null;

  // ---------- 2F Business Model ----------
  const businessModelData = {
    B2B: {
      model: "B2B",
      investor: "High",
      bestFit: "SaaS, AI, InfraTech, FinTech"
    },
    B2C: {
      model: "B2C",
      investor: "Moderate",
      bestFit: "Consumer Apps, D2C"
    },
    B2B2C: {
      model: "B2B2C",
      investor: "Very High",
      bestFit: "Marketplaces, EdTech"
    },
    C2C: {
      model: "C2C",
      investor: "Niche",
      bestFit: "Sharing Economy"
    },
    SME: {
      model: "SME",
      investor: "Rising",
      bestFit: "Finance, Accounting, Logistics"
    }
  };

  const businessModelContent = businessModelData[businessModelValue] || null;

  return (
    <>
    <QTag
      q="What type of offering are you building, who is your primary customer segment, and what is your business model?"
      a={`Offering: ${offeringValue || "—"} · Necessity: ${necessityValue || "—"} · Segment: ${painSegmentValue || "—"} · Model: ${businessModelValue || "—"}`}
      impacts="Problem urgency, customer pain level, revenue potential, investor fit, market-model alignment"
    />
    <div style={{ padding: "24px" }}>
      <div className="final-table">
        <table className="third-module-table">
          <span className="corner3 top-left"></span>
          <span className="corner3 top-right"></span>
          <span className="corner3 bottom-left"></span>
          <span className="corner3 bottom-right"></span>

          <thead>
            <tr>
              <th colSpan="3" className="module3-title">
                 <span className="module-prefix">Module 2:</span>  Guided Problem & Customer Discovery
              </th>
            </tr>
          </thead>

          {/* Static NA Table */}
       
<table className="std-table no-border-wrapper">
  <tbody>
    <tr>
      <td colSpan="3" className="no-border-cell">
        <table className="inner-table-report1">
          <tbody>
            <tr>
              <td className="serial-col">2 A</td>
              <td rowSpan={2} className="no-bold">Na</td>
              <td rowSpan={2} className="no-bold">Hence Both have 'Na' Tag</td>
            </tr>
            <tr>
              <td className="serial-col">2 B</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>



{/* 2C */}
{necessityValue && (
  <table className="std-table">
    <tbody>
      <tr>
        <td className="serial-col">2 C</td>
        <td>{necessityValue}</td>
        <td>{necessityContent}</td>
      </tr>
    </tbody>
  </table>
)}

{/* 2D */}
{offeringValue && (
  <table className="std-table">
    <tbody>
      <tr>
        <td className="serial-col">2 D</td>
        <td>{offeringValue}</td>
        <td>{offeringContent}</td>
      </tr>
    </tbody>
  </table>
)}

{/* 2E */}
{painContent && (
  <div className="scroll-wrapper">
    <table className="std-table five-cols">

      <thead>
        <tr>
          <th className="serial-col">S.NO</th>
          <th>Category</th>
          <th>Pain Level</th>
          <th>Revenue</th>
          <th>Why</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="serial-col">2 E</td>
          <td>{painContent.category}</td>
          <td>{painContent.painLevel}</td>
          <td>{painContent.revenue}</td>
          <td>{painContent.why}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}

{/* 2F */}
{businessModelContent && (
  <table className="std-table four-cols">

    <thead>
      <tr>
        <th className="serial-col">S.NO</th>
        <th>Model Type</th>
        <th>Investor Potential</th>
        <th>Best Fit For</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="serial-col">2 F</td>
        <td>{businessModelContent.model}</td>
        <td>{businessModelContent.investor}</td>
        <td>{businessModelContent.bestFit}</td>
      </tr>
    </tbody>
  </table>
)}


        </table>
      </div>
    </div>
    </>
  );
};

export default ThirdReport;
